import {startLoading, stopLoading} from "@slices/loader.slice";
import {store} from "@store";
import axios from "axios";
import {ApplicationResponse} from "../domain/common.model";
import {showErrorToast, showSuccessToast} from "@utils/toast.utils";

const api = axios.create({
    headers: {
        common: {
            "Accept": "application/json",
        }
    }
});

api.interceptors.request.use(
  (config) => {
    // Get token from Redux or localStorage as fallback
    const state = store.getState();
    let token: string | undefined = state.auth?.token?.data;
    
    // If token is not in Redux, try localStorage as fallback
    if (!token) {
      const localToken = localStorage.getItem("authToken");
      // Convert null to undefined for type compatibility
      token = localToken || undefined;
    }
    if (!config.url?.includes("auth/login")){
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    }

    store.dispatch(startLoading());
    return config;
  },
  (error) => {
    store.dispatch(stopLoading());
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    store.dispatch(stopLoading());
    const params = response.config.params;
    const data = response.data as ApplicationResponse<any>;
    if (
      data.status === "RESOURCE_CREATED" ||
      data.status === "RESOURCE_UPDATED" ||
      data.status === "RESOURCE_DELETED"
    ) {
      showSuccessToast(data.message);
      if (params && params.RAR !== undefined && params.RAR !== 0) {
        window.location.reload();
      }
    }
    if (data.status === "ERROR") {
      showErrorToast(data.message);
    }
    return response;
  },
  (error) => {
    store.dispatch(stopLoading());
    
    if (error.response) {
      const status = error.response.status;
      
      if (status === 401) {
        // Clear invalid token
        localStorage.removeItem("authToken");
        showErrorToast("Session expired. Please log in again.");
        // Optional: Redirect to login
        window.location.href = "/login";
      } else if (status === 403) {
        showErrorToast("You don't have permission to perform this action.");
      } else if (status === 404) {
        showErrorToast("Resource not found.");
      } else if (status >= 500) {
        showErrorToast("Server error. Please try again later.");
      } else {
        const errorMessage = error.response.data?.message || "An error occurred";
        showErrorToast(errorMessage);
      }
    } else if (error.request) {
      showErrorToast("Network error. Please check your connection.");
    } else {
      showErrorToast("An error occurred. Please try again.");
    }
    
    return Promise.reject(error);
  }
);

export const setupAxiosInterceptors = (store: any) => {
  api.interceptors.request.use(
    (config) => {
      const state = store.getState();
      let token: string | undefined = state.auth?.token?.data; 

      // If token is not in Redux, try localStorage as fallback
      if (!token) {
        const localToken = localStorage.getItem("authToken");
        // Convert null to undefined for type compatibility
        token = localToken || undefined;
      }
      if (!config.url?.includes("auth/login")) {
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default api;